const window = require('window');

const fbStandardEvents = [
    'ViewContent',
    'Search',
    'AddToCart',
    'AddToWishlist',
    'InitiateCheckout',
    'AddPaymentInfo',
    'Purchase',
    'Lead',
    'CompleteRegistration'
];

// Check HubSpot privacy consent banner
var _hsp = window._hsp = window._hsp || [];
_hsp.push(['addPrivacyConsentListener', privacyConsentCallback]);

// Set gtag default consent
window.dataLayer = window.dataLayer || [];
function gtag() { dataLayer.push(arguments); }

// Update consent based on HubSpot privacy banner
function privacyConsentCallback() {
    _hsp.push(['addPrivacyConsentListener', function(consent) {
        if (typeof fbq != 'undefined') {
            const fbConsent = consent.categories.advertisement ? 'grant' : 'revoke';
            fbq('consent', fbConsent);
        }

        var newConstentState = {
            'ad_user_data': consent.categories.advertisement ? 'granted' : 'denied',
            'ad_personalization': consent.categories.advertisement ? 'granted' : 'denied',
            'ad_storage': consent.categories.advertisement ? 'granted' : 'denied',
            'analytics_storage': consent.categories.analytics ? 'granted' : 'denied'
        };
        gtag('consent', 'update', newConstentState);

        // Load LinkedIn if consent is given
        if (consent.categories.advertisement) {
            window._linkedin_data_partner_id = "332321";
            var firstScript = window.document.getElementsByTagName("script")[0];
            var linkedInScript = window.document.createElement("script");
            linkedInScript.type = "text/javascript";
            linkedInScript.async = true;
            linkedInScript.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
            firstScript.parentNode.insertBefore(linkedInScript, firstScript);
        }
    }]);
}

export function track(eventCategory, eventAction, eventLabel) {
    if (typeof gtag != 'undefined') {
        gtag('event', eventAction, {
            'event_category': eventCategory,
            'event_label': eventLabel
        });
    }

    if (typeof fbq != 'undefined') {
        if (fbStandardEvents.indexOf(eventAction) !== -1) {
            fbq('track', eventAction);
        } else {
            fbq('trackCustom', eventCategory + '-' + eventAction, {
                category: eventCategory,
                action: eventAction,
                label: eventLabel
            });
        }
    }
}

export function trackOutbound(href, eventCategory, eventAction, eventLabel) {
  if (typeof gtag != 'undefined') {
      gtag('event', eventAction, {
          'event_category': eventCategory,
          'event_label': eventLabel,
          'event_callback': function() {
            document.location = href;
          }
      });
  }

  if (typeof fbq != 'undefined') {
      if (fbStandardEvents.indexOf(eventAction) !== -1) {
          fbq('track', eventAction);
      } else {
          fbq('trackCustom', eventCategory + '-' + eventAction, {
              category: eventCategory,
              action: eventAction,
              label: eventLabel
          });
      }
  }
}

export function track_ecommerce(transaction) {
    if (typeof fbq === 'undefined') {
        console.warn('fbq is undefined, not tracking ecommerce data.');
    } else {
        fbq('track', 'Purchase', {
            value: transaction.value,
            currency: transaction.currency
        });
    }

    if (typeof gtag === 'undefined') {
        console.warn('gtag is undefined, not tracking ecommerce data.', transaction);
    } else {
        if (window.adwords_send_to) {
            const conversion = {
                send_to: window.adwords_send_to,
                value: transaction.value,
                currency: transaction.currency,
                transaction_id: transaction.transactionId,
                event_callback: function () {
                    console.log('gtag', 'event', 'purchase', transaction);
                    gtag('event', 'purchase', transaction);
                }
            };
            console.log('gtag', 'event', 'conversion', conversion);
            gtag('event', 'conversion', conversion);
        } else {
            console.log('gtag', 'event', 'purchase', transaction);
            gtag('event', 'purchase', transaction);
        }
    }
}